import { useCallback, useEffect, useState } from 'react';

/**
 * ⌘K / Ctrl+K 로 문서 검색 열기.
 * 입력 중인 필드에서는 가로채지 않는다 — 문의 폼에서 ⌘K 를 누르면 안 되니까.
 */
export function useDocsSearch() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key.toLowerCase() !== 'k' || !(event.metaKey || event.ctrlKey)) return;

      const target = event.target as HTMLElement | null;
      const tag = target?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || target?.isContentEditable) return;

      event.preventDefault();
      setOpen((prev) => !prev);
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return { open, openSearch: useCallback(() => setOpen(true), []), closeSearch: useCallback(() => setOpen(false), []) };
}
